import React, { useState } from 'react';
import { validate } from '../../../validate';
import { api, getTenant, getUserName } from '../../../../../hooks';
import { IBLSpinLoader } from '../../../../IBLSpinLoader';


const CompanyMenu = ({ hideCompanyMenu, setCompanies, setPositionData }) => {
  const [companyData, setCompanyData] = useState({
    name: '',
    industry: 'Information Technology',
    website: '',
    logo: '',
    is_current: true,
  });

  const [isLoading, setIsLoading] = useState(false);

const [errors, setErrors] = useState({});

const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCompanyData({ ...companyData, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

     const requiredFields = [
       'name',
       'website',
       
     ];

  const handleSave = () => {

    // Add your save logic here
        const newErrors = validate(companyData, requiredFields);
        if (Object.keys(newErrors).length > 0) {
          setErrors(newErrors);
          return;
        }

    

        try {
          new URL(companyData.website); // Validate URL
        } catch (e) {
          setErrors({ ...errors, website: 'Invalid URL format' });
          return;
        }

            setIsLoading(true);

         api.ibldmcareer.postCompany(
           { org: getTenant(), username: getUserName() },
           JSON.stringify(companyData),
           (data) => {
            setCompanies(prevCompanies => [...prevCompanies, data]);
            setPositionData(prevPositionData => ({...prevPositionData, company_id: data.id}));
            setIsLoading(false);
            window.alert('Company added successfully');
            hideCompanyMenu();
           },
           (error) => {
            setIsLoading(false);
            window.alert('Something went wrong, Please try again later');
            hideCompanyMenu();
           }
         );


        
  };

  return (
    <div
      data-name="followers"
      className="edit_profile_pop add-company-pop hidden active"
      style={{ display: 'block' }}
    >
      <div className="div-block-520">
        <div className="text-block-386">Add Company</div>
        <div className="cancel_edit_profile w-embed" onClick={hideCompanyMenu}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="var(--accent)"
            height="16px"
            width="16px"
            version="1.1"
            id="Capa_1"
            viewBox="0 0 460.775 460.775"
            xmlSpace="preserve"
          >
            <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55  c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55  c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505  c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55  l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719  c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z" />
          </svg>
        </div>
      </div>
      {isLoading ? (
        <IBLSpinLoader size={40} containerHeight={'200px'} />
      ) : (
        <>
          <div className="div-block-525">
            <div className="div-block-469 sk_s form_div">
              <div className="form_row">
                <div className="text-block-297">Name</div>
                <div className="form-block-15 s_skill w-form">
                  <form
                    id="email-form"
                    name="email-form"
                    data-name="Email Form"
                    method="get"
                    className="form-10"
                    data-wf-page-id="6596f9cde7a06c303cf07fbf"
                    data-wf-element-id="45c1b1a9-2ea7-4111-35be-725a32ecd6d0"
                    aria-label="Email Form"
                  >
                    <input
                      className="text-field-14 form_text w-input"
                      maxLength={256}
                      name="name"
                      data-name="Name"
                      placeholder="E.g IBL Education"
                      type="text"
                      value={companyData.name}
                      onChange={handleInputChange}
                    />
                  </form>
                  { "name" in errors && (
                    <div className="error-message" style={{ color: '#CB112D' }}>
                      {errors.name as string}
                    </div>
                  )}
                </div>
              </div>
              <div className="form_row">
                <div className="text-block-297">Industry</div>
                <div className="form-block-15 s_skill w-form">
                  <form
                    id="email-form"
                    name="email-form"
                    data-name="Email Form"
                    method="get"
                    className="form-10"
                    data-wf-page-id="6596f9cde7a06c303cf07fbf"
                    data-wf-element-id="45c1b1a9-2ea7-4111-35be-725a32ecd6dc"
                    aria-label="Email Form"
                  >
                    <select
                      id="field-2"
                      name="industry"
                      data-name="Industry"
                      className="select-field-3 w-select"
                      value={companyData.industry}
                      onChange={handleInputChange}
                    >
                        <option value="Information Technology">Information Technology</option>
                        <option value="Healthcare">Healthcare</option>
                        <option value="Finance">Finance</option>
                        <option value="Education">Education</option>
                        <option value="Manufacturing">Manufacturing</option>
                        <option value="Retail">Retail</option>
                        <option value="Construction">Construction</option>
                        <option value="Transportation and Logistics">Transportation and Logistics</option>
                        <option value="Real Estate">Real Estate</option>
                        <option value="Energy">Energy</option>
                        <option value="Telecommunications">Telecommunications</option>
                        <option value="Hospitality and Tourism">Hospitality and Tourism</option>
                        <option value="Agriculture">Agriculture</option>
                        <option value="Media and Entertainment">Media and Entertainment</option>
                        <option value="Aerospace and Defense">Aerospace and Defense</option>
                        <option value="Legal Services">Legal Services</option>
                        <option value="Nonprofit">Nonprofit</option>
                        <option value="Government">Government</option>
                        <option value="Automotive">Automotive</option>
                        <option value="Pharmaceuticals">Pharmaceuticals</option>
                        <option value="Pharmaceuticals">Other</option>

                    </select>
                  </form>
                </div>
              </div>
              <div className="form_row">
                <div className="text-block-297">Website URL</div>
                <div className="form-block-15 s_skill w-form">
                  <form
                    id="email-form"
                    name="email-form"
                    data-name="Email Form"
                    method="get"
                    className="form-10"
                    data-wf-page-id="6596f9cde7a06c303cf07fbf"
                    data-wf-element-id="45c1b1a9-2ea7-4111-35be-725a32ecd6f8"
                    aria-label="Email Form"
                  >
                    <input
                      className="text-field-14 form_text w-input"
                      maxLength={256}
                      name="website"
                      data-name="Website URL"
                      placeholder="https://www.bl.ai"
                      type="url"
                      value={companyData.website}
                      onChange={handleInputChange}
                    />
                  </form>
                  { "website" in errors && (
                    <div className="error-message" style={{ color: '#CB112D' }}>
                      {errors.website as string}
                    </div>
                  )}
                </div>
              </div>
              <div className="form_row" style={{ display: 'none' }}>
                <div className="text-block-297">Logo</div>
                <div className="form-block-15 s_skill w-form">
                  <form
                    id="email-form"
                    name="email-form"
                    data-name="Email Form"
                    method="get"
                    className="form-10"
                    data-wf-page-id="6596f9cde7a06c303cf07fbf"
                    data-wf-element-id="f33b4d7b-270f-3177-5d5d-7f4089590760"
                    aria-label="Email Form"
                  >
                    <input
                      className="text-field-14 form_text w-input"
                      maxLength={256}
                      name="logo"
                      data-name="Logo"
                      placeholder="Upload the company's logo"
                      type="text"
                      value={companyData.logo}
                      onChange={handleInputChange}
                    />
                    <div className="div-block-475 file_upload">
                      <div className="text-block-284 add_skill_text">
                        Upload
                      </div>
                    </div>
                  </form>
                  { "logo" in errors && (
                    <div className="error-message" style={{ color: '#CB112D' }}>
                      {errors.logo as string}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="popup-f add_content">
            <div
              className="div-block-475 cancel_edit_prof"
              onClick={hideCompanyMenu}
            >
              <div className="text-block-284 cancel_dc">Cancel</div>
            </div>
            <div
              className="div-block-475 save_profile_info"
              onClick={handleSave}
            >
              <div className="text-block-284 add_skill_text">Save</div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CompanyMenu;
